<template>
  <footer v-if="variants.main === variant" class="footer" style="background-color: var(--dark-brown)">
    <div class="page-padding">
      <div class="container-large">
        <div class="padding-vertical padding-xhuge">
          <div class="w-layout-grid footer-component-grid">
            <div id="w-node-_103b4bea-4a5e-266e-2bf1-8a17dc59e522-dc59e506" class="inner-content block-1">
              <div class="footer-title">{{ vars.title1Text }}</div>
              <div class="margin-top margin-medium">
                <div class="nav-footer-content">
                  <ul role="list" class="footer-nav-list w-list-unstyled">
                    <li v-for="(menu, index) in footerMenuItems" :key="`page-${index}`" class="footer-nav-item">
                      <nuxt-link
                        v-if="menu.url !== 'url'"
                        :to="menu.url"
                        class="footer-nav-link w-inline-block w--current"
                        data-w-id="103b4bea-4a5e-266e-2bf1-8a17dc59e529"
                        :external="true"
                        :target="menu.is_open_new_tab ? '_blank' : ''"
                      >
                        {{ menu.name }}
                        <div class="hover-underline"></div>
                      </nuxt-link>
                      <a
                        v-else
                        :href="menu.url"
                        aria-current="page"
                        class="footer-nav-link w-inline-block w--current"
                        data-w-id="103b4bea-4a5e-266e-2bf1-8a17dc59e529"
                      >
                        {{ menu.name }}
                        <div class="hover-underline"></div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div id="w-node-_103b4bea-4a5e-266e-2bf1-8a17dc59e54b-dc59e506" class="inner-content block-2">
              <div class="footer-title">{{ vars.title2Text }}</div>
              <div class="margin-top margin-medium">
                <div class="nav-footer-content">
                  <ul role="list" class="footer-nav-list w-list-unstyled">
                    <li v-for="(contact, index) in contacts" :key="`contact-${index}`" class="footer-nav-item">
                      <nuxt-link
                        data-w-id="103b4bea-4a5e-266e-2bf1-8a17dc59e552"
                        :to="contact.link"
                        class="footer-nav-link w-inline-block"
                        :external="true"
                        :target="contact.is_new_tab ? '_blank' : ''"
                      >
                        <div>{{ contact.item }}</div>
                        <div class="hover-underline"></div>
                      </nuxt-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              id="w-node-_103b4bea-4a5e-266e-2bf1-8a17dc59e50b-dc59e506"
              class="bydesign-center-footer d-flex flex-column align-items-center pt-3"
            >
              <nuxt-link
                to="/"
                :external="true"
                aria-current="page"
                class="logo-link w-inline-block w--current tw-mb-12 tw-mt-8 lg:tw-mt-0"
                ><img :src="company.logo" loading="lazy" :width="200" alt="ByDesign"
              /></nuxt-link>
              <div class="footer-description d-flex justify-content-center flex-column align-items-center">
                <p>{{ vars.title3Text }}</p>
                <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-x-4 tw-gap-y-2">
                  <NuxtImg
                    v-for="(reference, index) in references"
                    :key="`reference-${index}`"
                    class="reference-image"
                    :src="reference.image"
                    :width="100"
                    quality="60"
                  />
                </div>
              </div>
              <div
                class="footer-description margin-top margin-medium d-flex flex-wrap align-items-center gap-2 flex-column mt-4"
              >
                <p>{{ vars.title4Text }}</p>

                <div class="social-media-content">
                  <a
                    v-if="vars.facebookUrl"
                    :href="vars.facebookUrl"
                    target="_blank"
                    class="social-link w-inline-block"
                  >
                    <div></div>
                  </a>
                  <a
                    v-if="vars.instagramUrl"
                    :href="vars.instagramUrl"
                    target="_blank"
                    class="social-link w-inline-block"
                  >
                    <div></div>
                  </a>

                  <a
                    v-if="vars.linkedinUrl"
                    :href="vars.linkedinUrl"
                    target="_blank"
                    class="social-link w-inline-block"
                  >
                    <div></div>
                  </a>
                  <a v-if="vars.youtubeUrl" :href="vars.youtubeUrl" target="_blank" class="social-link w-inline-block">
                    <div></div>
                  </a>
                </div>
              </div>
            </div>

            <div id="w-node-_103b4bea-4a5e-266e-2bf1-8a17dc59e56f-dc59e506" class="inner-content block-3">
              <div class="margin-top margin-medium">
                <div class="nav-footer-content">
                  <ul role="list" class="footer-nav-list w-list-unstyled">
                    <br />
                    <li v-if="vars.branchNameText && variant === 'office_detail'" class="footer-nav-item">
                      <a
                        data-w-id="103b4bea-4a5e-266e-2bf1-8a17dc59e529"
                        aria-current="page"
                        class="footer-nav-link w-inline-block w--current branch-name"
                      >
                        <div>{{ vars.branchNameText }}</div>
                        <div class="hover-underline"></div>
                      </a>
                    </li>

                    <li
                      v-if="
                        variant === 'office_detail' &&
                        (vars.branchFacebookUrl ||
                          vars.branchInstagramUrl ||
                          vars.branchLinkedinUrl ||
                          vars.branchYoutubeUrl)
                      "
                      class="footer-nav-item tw-mb-5"
                    >
                      <div class="social-media-content">
                        <a
                          v-if="vars.branchFacebookUrl"
                          :href="vars.branchFacebookUrl"
                          target="_blank"
                          class="social-link w-inline-block"
                        >
                          <div></div>
                        </a>
                        <a
                          v-if="vars.branchInstagramUrl"
                          :href="vars.branchInstagramUrl"
                          target="_blank"
                          class="social-link w-inline-block"
                        >
                          <div></div>
                        </a>

                        <a
                          v-if="vars.branchLinkedinUrl"
                          :href="vars.branchLinkedinUrl"
                          target="_blank"
                          class="social-link w-inline-block"
                        >
                          <div></div>
                        </a>
                        <a
                          v-if="vars.branchYoutubeUrl"
                          :href="vars.branchYoutubeUrl"
                          target="_blank"
                          class="social-link w-inline-block"
                        >
                          <div></div>
                        </a>
                      </div>
                    </li>

                    <li v-if="vars.companyTradingAsText" class="footer-nav-item">
                      <a
                        data-w-id="103b4bea-4a5e-266e-2bf1-8a17dc59e529"
                        aria-current="page"
                        class="footer-nav-link w-inline-block w--current"
                      >
                        <div>{{ vars.companyTradingAsText }}</div>
                        <div class="hover-underline"></div>
                      </a>
                    </li>
                    <li v-if="vars.companyNameText" class="footer-nav-item">
                      <a data-w-id="103b4bea-4a5e-266e-2bf1-8a17dc59e52e" class="footer-nav-link w-inline-block">
                        <div>{{ vars.companyNameText }}</div>
                        <div class="hover-underline"></div>
                      </a>
                    </li>
                    <li v-if="vars.companyNumberNumber" class="footer-nav-item">
                      <a data-w-id="103b4bea-4a5e-266e-2bf1-8a17dc59e533" class="footer-nav-link w-inline-block">
                        <div>Company Number: {{ vars.companyNumberNumber }}</div>
                        <div class="hover-underline"></div>
                      </a>
                    </li>
                    <li class="footer-nav-item">
                      <a data-w-id="103b4bea-4a5e-266e-2bf1-8a17dc59e538" class="footer-nav-link w-inline-block">
                        <div>Registered Address: {{ vars.companyAddressText }}</div>
                        <div class="hover-underline"></div>
                      </a>
                    </li>
                    <li v-if="vars.companyRedressSchemeItemText" class="footer-nav-item">
                      <a data-w-id="103b4bea-4a5e-266e-2bf1-8a17dc59e53d" class="footer-nav-link w-inline-block">
                        <div>
                          Redress Scheme:
                          {{ vars.companyRedressSchemeItemText }}
                        </div>
                        <div class="hover-underline"></div>
                      </a>
                    </li>
                    <li v-if="vars.companyRedressSchemeLinkUrl" class="footer-nav-item">
                      <a
                        data-w-id="103b4bea-4a5e-266e-2bf1-8a17dc59e547"
                        :href="vars.companyRedressSchemeLinkUrl"
                        class="footer-nav-link w-inline-block"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div>{{ vars.companyRedressSchemeLinkUrl }}</div>
                        <div class="hover-underline"></div>
                      </a>
                    </li>
                    <li
                      v-if="redressLogos && redressLogos.length"
                      class="footer-nav-item tw-flex tw-flex-wrap tw-justify-center tw-gap-x-2 lg:tw-justify-start"
                    >
                      <a
                        v-for="(logo, index) in redressLogos"
                        :key="`redressLogos-${index}`"
                        data-w-id="103b4bea-4a5e-266e-2bf1-8a17dc59e547"
                        class="footer-nav-link w-inline-block"
                      >
                        <img
                          style="max-height: 42px"
                          :title="logo.schemelogoalt"
                          :alt="logo.schemelogoalt"
                          :src="logo.schemelogo"
                        />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom-content">
      <div class="page-padding d-flex flex-column align-items-center gap-5">
        <div class="text-bottom">
          <library-footer-iceberg-links />
        </div>
        <div class="text-bottom">© {{ currentYear }} {{ vars.companyText }}. All rights reserved.</div>
      </div>
    </div>
  </footer>

  <footer
    v-if="variants.v2 === variant"
    class="tw-flex tw-flex-col tw-text-start"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-white)'}`"
  >
    <div
      class="tw-flex tw-flex-col tw-justify-center tw-gap-14 tw-p-8 tw-pb-8 sm:tw-p-12 lg:tw-pt-24 2xl:tw-gap-6 2xl:tw-px-32"
    >
      <div
        class="tw-flex tw-flex-col tw-items-center tw-gap-12 lg:tw-flex-row lg:tw-flex-wrap lg:tw-items-start xl:tw-grid xl:tw-auto-rows-max xl:tw-grid-cols-3 xl:tw-items-start"
      >
        <!-- Logo and socials -->
        <div
          class="tw-flex tw-flex-col tw-items-center tw-gap-5 tw-text-center lg:tw-flex-[100%] xl:tw-col-start-2 xl:tw-row-start-1"
        >
          <NuxtImg :src="company.logo" class="tw-max-w-36 sm:tw-max-w-40 lg:tw-w-40 xl:tw-w-52 xl:tw-max-w-52" />
          <div class="tw-flex tw-flex-row tw-gap-4">
            <nuxt-link
              v-if="vars.facebookUrl"
              :to="vars.facebookUrl"
              target="_blank"
              class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full hover:!tw-border-[var(--c-secondary)] hover:tw-bg-[var(--c-secondary)]"
              style="border: 1px solid white"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.33317 9.00016H10.9998L11.6665 6.3335H9.33317V5.00016C9.33317 4.3135 9.33317 3.66683 10.6665 3.66683H11.6665V1.42683C11.4492 1.39816 10.6285 1.3335 9.76184 1.3335C7.95184 1.3335 6.6665 2.43816 6.6665 4.46683V6.3335H4.6665V9.00016H6.6665V14.6668H9.33317V9.00016Z"
                  fill="white"
                />
              </svg>
            </nuxt-link>
            <nuxt-link
              v-if="vars.instagramUrl"
              :to="vars.instagramUrl"
              target="_blank"
              class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full hover:!tw-border-[var(--c-secondary)] hover:!tw-bg-[var(--c-secondary)]"
              style="border: 1px solid white"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.20016 1.3335H10.8002C12.9335 1.3335 14.6668 3.06683 14.6668 5.20016V10.8002C14.6668 11.8257 14.2594 12.8092 13.5343 13.5343C12.8092 14.2594 11.8257 14.6668 10.8002 14.6668H5.20016C3.06683 14.6668 1.3335 12.9335 1.3335 10.8002V5.20016C1.3335 4.17466 1.74088 3.19116 2.46602 2.46602C3.19116 1.74088 4.17466 1.3335 5.20016 1.3335ZM5.06683 2.66683C4.43031 2.66683 3.81986 2.91969 3.36977 3.36977C2.91969 3.81986 2.66683 4.43031 2.66683 5.06683V10.9335C2.66683 12.2602 3.74016 13.3335 5.06683 13.3335H10.9335C11.57 13.3335 12.1805 13.0806 12.6306 12.6306C13.0806 12.1805 13.3335 11.57 13.3335 10.9335V5.06683C13.3335 3.74016 12.2602 2.66683 10.9335 2.66683H5.06683ZM11.5002 3.66683C11.7212 3.66683 11.9331 3.75463 12.0894 3.91091C12.2457 4.06719 12.3335 4.27915 12.3335 4.50016C12.3335 4.72118 12.2457 4.93314 12.0894 5.08942C11.9331 5.2457 11.7212 5.3335 11.5002 5.3335C11.2791 5.3335 11.0672 5.2457 10.9109 5.08942C10.7546 4.93314 10.6668 4.72118 10.6668 4.50016C10.6668 4.27915 10.7546 4.06719 10.9109 3.91091C11.0672 3.75463 11.2791 3.66683 11.5002 3.66683ZM8.00016 4.66683C8.88422 4.66683 9.73206 5.01802 10.3572 5.64314C10.9823 6.26826 11.3335 7.11611 11.3335 8.00016C11.3335 8.88422 10.9823 9.73206 10.3572 10.3572C9.73206 10.9823 8.88422 11.3335 8.00016 11.3335C7.11611 11.3335 6.26826 10.9823 5.64314 10.3572C5.01802 9.73206 4.66683 8.88422 4.66683 8.00016C4.66683 7.11611 5.01802 6.26826 5.64314 5.64314C6.26826 5.01802 7.11611 4.66683 8.00016 4.66683ZM8.00016 6.00016C7.46973 6.00016 6.96102 6.21088 6.58595 6.58595C6.21088 6.96102 6.00016 7.46973 6.00016 8.00016C6.00016 8.5306 6.21088 9.0393 6.58595 9.41438C6.96102 9.78945 7.46973 10.0002 8.00016 10.0002C8.5306 10.0002 9.0393 9.78945 9.41438 9.41438C9.78945 9.0393 10.0002 8.5306 10.0002 8.00016C10.0002 7.46973 9.78945 6.96102 9.41438 6.58595C9.0393 6.21088 8.5306 6.00016 8.00016 6.00016Z"
                  fill="white"
                />
              </svg>
            </nuxt-link>
            <nuxt-link
              v-if="vars.linkedinUrl"
              :to="vars.linkedinUrl"
              target="_blank"
              class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full hover:!tw-border-[var(--c-secondary)] hover:!tw-bg-[var(--c-secondary)]"
              style="border: 1px solid white"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.62663 3.33351C4.62645 3.68713 4.48581 4.0262 4.23563 4.27613C3.98546 4.52605 3.64625 4.66636 3.29263 4.66618C2.93901 4.666 2.59994 4.52536 2.35001 4.27518C2.10009 4.02501 1.95978 3.6858 1.95996 3.33218C1.96014 2.97856 2.10078 2.63949 2.35096 2.38956C2.60113 2.13964 2.94034 1.99934 3.29396 1.99951C3.64758 1.99969 3.98665 2.14033 4.23658 2.39051C4.4865 2.64068 4.6268 2.97989 4.62663 3.33351ZM4.66663 5.65351H1.99996V14.0002H4.66663V5.65351ZM8.87996 5.65351H6.22663V14.0002H8.85329V9.62018C8.85329 7.18018 12.0333 6.95351 12.0333 9.62018V14.0002H14.6666V8.71351C14.6666 4.60018 9.95996 4.75351 8.85329 6.77351L8.87996 5.65351Z"
                  fill="white"
                />
              </svg>
            </nuxt-link>
            <nuxt-link
              v-if="vars.youtubeUrl"
              :to="vars.youtubeUrl"
              target="_blank"
              class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full hover:!tw-border-[var(--c-secondary)] hover:!tw-bg-[var(--c-secondary)]"
              style="border: 1px solid white"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_23_2087)">
                  <path
                    d="M8.00016 2.6665C8.57016 2.6665 9.15483 2.68117 9.7215 2.70517L10.3908 2.73717L11.0315 2.77517L11.6315 2.81584L12.1795 2.8585C12.7742 2.90402 13.3338 3.1578 13.7598 3.5752C14.1859 3.99259 14.4511 4.54686 14.5088 5.1405L14.5355 5.42384L14.5855 6.0305C14.6322 6.65917 14.6668 7.3445 14.6668 7.99984C14.6668 8.65517 14.6322 9.3405 14.5855 9.96917L14.5355 10.5758C14.5268 10.6732 14.5182 10.7672 14.5088 10.8592C14.4511 11.4529 14.1858 12.0073 13.7596 12.4247C13.3334 12.8421 12.7736 13.0958 12.1788 13.1412L11.6322 13.1832L11.0322 13.2245L10.3908 13.2625L9.7215 13.2945C9.14805 13.3194 8.57415 13.3323 8.00016 13.3332C7.42618 13.3323 6.85227 13.3194 6.27883 13.2945L5.6095 13.2625L4.96883 13.2245L4.36883 13.1832L3.82083 13.1412C3.22613 13.0957 2.66653 12.8419 2.24048 12.4245C1.81443 12.0071 1.54921 11.4528 1.4915 10.8592L1.46483 10.5758L1.41483 9.96917C1.36385 9.31393 1.33673 8.65705 1.3335 7.99984C1.3335 7.3445 1.36816 6.65917 1.41483 6.0305L1.46483 5.42384C1.4735 5.3265 1.48216 5.2325 1.4915 5.1405C1.54919 4.54697 1.81431 3.99278 2.24022 3.5754C2.66614 3.15802 3.22558 2.90417 3.82016 2.8585L4.3675 2.81584L4.9675 2.77517L5.60883 2.73717L6.27816 2.70517C6.85183 2.68026 7.42596 2.66737 8.00016 2.6665ZM8.00016 3.99984C7.45016 3.99984 6.88416 4.0145 6.3335 4.03717L5.6815 4.0685L5.0555 4.10517L4.4675 4.14517L3.92883 4.18717C3.64572 4.20726 3.37886 4.32693 3.17556 4.52499C2.97226 4.72304 2.84564 4.98668 2.81816 5.26917C2.74016 6.07517 2.66683 7.0785 2.66683 7.99984C2.66683 8.92117 2.74016 9.9245 2.81816 10.7305C2.87483 11.3118 3.33616 11.7638 3.92883 11.8125L4.4675 11.8538L5.0555 11.8938L5.6815 11.9312L6.3335 11.9625C6.88416 11.9852 7.45016 11.9998 8.00016 11.9998C8.55016 11.9998 9.11616 11.9852 9.66683 11.9625L10.3188 11.9312L10.9448 11.8945L11.5328 11.8545L12.0715 11.8125C12.3546 11.7924 12.6215 11.6727 12.8248 11.4747C13.0281 11.2766 13.1547 11.013 13.1822 10.7305C13.2602 9.9245 13.3335 8.92117 13.3335 7.99984C13.3335 7.0785 13.2602 6.07517 13.1822 5.26917C13.1547 4.98668 13.0281 4.72304 12.8248 4.52499C12.6215 4.32693 12.3546 4.20726 12.0715 4.18717L11.5328 4.14584L10.9448 4.10584L10.3188 4.0685L9.66683 4.03717C9.11159 4.01328 8.55592 4.00083 8.00016 3.99984ZM6.66683 6.38317C6.66679 6.31801 6.68266 6.25383 6.71307 6.19621C6.74349 6.13858 6.78751 6.08926 6.84133 6.05253C6.89515 6.01579 6.95712 5.99277 7.02187 5.98544C7.08661 5.97812 7.15217 5.98672 7.21283 6.0105L7.26683 6.03717L10.0668 7.65317C10.1226 7.68534 10.1698 7.73049 10.2043 7.78479C10.2389 7.83909 10.2599 7.90094 10.2654 7.96507C10.271 8.0292 10.261 8.09373 10.2363 8.15317C10.2116 8.21261 10.1729 8.26521 10.1235 8.3065L10.0668 8.3465L7.26683 9.96317C7.2104 9.99584 7.14685 10.0142 7.08169 10.0167C7.01654 10.0192 6.95176 10.0058 6.893 9.97749C6.83424 9.94923 6.78328 9.90703 6.74456 9.85457C6.70584 9.80211 6.68053 9.74098 6.67083 9.6765L6.66683 9.6165V6.38317Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_23_2087">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </nuxt-link>
            <nuxt-link
              v-if="vars.tiktokUrl"
              :to="vars.tiktokUrl"
              target="_blank"
              class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full hover:!tw-border-[var(--c-secondary)] hover:!tw-bg-[var(--c-secondary)]"
              style="border: 1px solid white"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.0668 3.88C10.6111 3.35975 10.3599 2.69162 10.3601 2H8.3001V10.2667C8.28422 10.714 8.09535 11.1377 7.77328 11.4486C7.45121 11.7595 7.02107 11.9333 6.57344 11.9333C5.62677 11.9333 4.8401 11.16 4.8401 10.2C4.8401 9.05333 5.94677 8.19333 7.08677 8.54667V6.44C4.78677 6.13333 2.77344 7.92 2.77344 10.2C2.77344 12.42 4.61344 14 6.56677 14C8.6601 14 10.3601 12.3 10.3601 10.2V6.00667C11.1954 6.60657 12.1983 6.92843 13.2268 6.92667V4.86667C13.2268 4.86667 11.9734 4.92667 11.0668 3.88Z"
                  fill="white"
                />
              </svg>
            </nuxt-link>
          </div>
        </div>
        <!-- Links -->
        <div
          class="tw-flex tw-flex-row tw-flex-wrap tw-justify-start tw-gap-12 md:tw-w-full lg:tw-flex-[40%] lg:tw-flex-nowrap lg:tw-justify-center xl:tw-col-start-1 xl:tw-row-start-1 xl:tw-w-auto xl:tw-gap-16"
        >
          <!-- Column 1 Links -->
          <div class="tw-flex tw-min-w-[140px] tw-flex-col tw-items-start tw-gap-8 tw-text-start xl:tw-flex-[1_1_60%]">
            <p class="tw-break-normal tw-uppercase" style="color: var(--c-text-footer); letter-spacing: 4px">
              {{ vars.columnTitle1Text }}
            </p>
            <div class="tw-flex tw-flex-col tw-items-start tw-gap-3">
              <nuxt-link
                v-for="(column1, index) in columns1"
                :key="index"
                :to="column1.link"
                :external="true"
                style="letter-spacing: 0px"
                class="n-link underline tw-flex tw-flex-row tw-items-center tw-gap-2"
                ><span v-if="column1.icon"><NuxtImg :src="column1.icon" class="tw-w-4 tw-min-w-4" /></span>
                <span
                  class="tw-break-words tw-duration-300 hover:!tw-text-[var(--c-secondary)]"
                  style="color: var(--c-text-footer)"
                >
                  {{ column1.item }}
                </span></nuxt-link
              >
            </div>
          </div>
          <!-- Column 2 Links -->
          <div class="tw-flex tw-min-w-[140px] tw-flex-col tw-items-start tw-gap-8 tw-text-start xl:tw-flex-[1_1_60%]">
            <p class="tw-break-normal tw-uppercase" style="color: var(--c-text-footer); letter-spacing: 4px">
              {{ vars.columnTitle2Text }}
            </p>
            <div class="tw-flex tw-flex-col tw-items-start tw-gap-3">
              <nuxt-link
                :external="true"
                v-for="(column2, index) in columns2"
                :key="`column2-${index}`"
                :to="column2.link"
                style="letter-spacing: 0px"
                class="n-link underline tw-flex tw-flex-row tw-items-center tw-gap-2 hover:tw-text-[var(--c-secondary)]"
                ><span v-if="column2.icon"><NuxtImg :src="column2.icon" class="tw-w-4 tw-min-w-4" /></span>
                <span
                  class="tw-break-words tw-duration-300 hover:!tw-text-[var(--c-secondary)] hover:tw-opacity-100"
                  style="color: var(--c-text-footer)"
                >
                  {{ column2.item }}
                </span></nuxt-link
              >
            </div>
          </div>
        </div>
        <!-- Company Info -->
        <div
          class="tw-flex tw-max-w-[400px] tw-flex-col tw-items-start tw-gap-2 tw-text-start md:tw-w-full md:tw-max-w-none lg:tw-flex-[40%] xl:tw-col-start-3 xl:tw-row-start-1"
        >
          <p style="color: var(--c-text-footer)">{{ vars.companyTradingAsText }}</p>
          <p style="color: var(--c-text-footer)">{{ vars.companyText }}</p>
          <p style="color: var(--c-text-footer)">Company Number: {{ vars.companyNumber }}</p>
          <p style="color: var(--c-text-footer)">Registered Address: {{ vars.companyAddressText }}</p>
          <p style="color: var(--c-text-footer)">
            Redress Scheme:
            {{ vars.companyRedressSchemeText }}
          </p>
          <p style="color: var(--c-text-footer)">
            <a
              data-w-id="103b4bea-4a5e-266e-2bf1-8a17dc59e547"
              :href="vars.companyRedressSchemeLinkUrl"
              class="n-link"
              target="_blank"
              rel="noreferrer"
            >
              {{ vars.companyRedressSchemeLinkUrl }}
            </a>
          </p>
          <a
            v-for="(logo, index) in redress"
            :key="`redressLogos-${index}`"
            data-w-id="103b4bea-4a5e-266e-2bf1-8a17dc59e547"
            class="n-link"
            style="color: var(--c-text-footer)"
          >
            <img style="max-height: 42px" :title="logo.title" :alt="logo.title" :src="logo.photo" />
          </a>
        </div>
      </div>
    </div>
    <div
      class="tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-y-3 tw-p-4 tw-text-center xl:tw-flex-col xl:tw-justify-center xl:tw-px-60"
      :style="`background-color: var(--c-${vars.backgroundColor});`"
    >
      <div
        class="tw-flex tw-flex-col tw-gap-x-10 tw-gap-y-5 md:tw-flex-row xl:tw-w-full xl:tw-items-center xl:tw-justify-center"
      >
        <p
          class="tw-flex-grow-0 tw-basis-1/3 tw-whitespace-nowrap xl:tw-text-center"
          style="color: var(--c-text-footer)"
        >
          Powered by
          <a href="https://www.iceberg-digital.co.uk/neuron/home" class="n-link" target="_blank"> Neuron</a>
          |
          <a href="https://www.iceberg-digital.co.uk/" class="n-link" target="_blank">Iceberg Digital</a>
        </p>
      </div>
    </div>
    <div class="tw-w-full tw-pb-6 tw-text-center">
      <p class="tw-flex-grow tw-basis-1/3 tw-whitespace-normal lg:tw-text-center" style="color: var(--c-text-footer)">
        © {{ new Date().getFullYear() }} {{ company.name }}. All rights reserved.
      </p>
    </div>
  </footer>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useWebsiteStore } from '~/units/website/store';
import FooterIcebergLinks from '~/components/library/FooterIcebergLinks.vue';

export default defineNuxtComponent({
  name: 'Theme2BaseFooterOne',
  components: { FooterIcebergLinks },

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        main: 'main',
        v2: 'v2',
      },
    };
  },

  computed: {
    ...mapState(useWebsiteStore, ['footerMenuItems']),

    currentYear() {
      return new Date().getFullYear();
    },

    variant() {
      return this.component.component_variant.name;
    },

    contacts() {
      return this.groupedVariables.contacts;
    },

    redressLogos() {
      return this.groupedVariables.redress;
    },

    references() {
      return this.groupedVariables.references;
    },

    columns1() {
      return this.groupedVariables.columns1;
    },

    columns2() {
      return this.groupedVariables.columns2;
    },

    redress() {
      return this.groupedVariables.redress;
    },

    routeUrl() {
      const route = useRoute();
      return route.path;
    },
  },
});
</script>

<style scoped>
.footer-component-grid {
  grid-template-columns: 1fr 1fr 4fr 2.5fr;
  grid-column-gap: 3%;
}

.padding-xhuge {
  padding: 4rem 0 0;
}

.inner-content {
  padding: 7rem 0 0;
}

.footer-description {
  max-width: unset;
}

.footer-nav-list {
  margin-right: unset;
}

.footer-title,
.footer-nav-link,
.footer-description p {
  font-weight: 200;
  color: var(--white);
}

@media screen and (max-width: 767px) {
  .footer-component-grid {
    grid-template-columns: 1fr !important;
    grid-row-gap: 1rem;
  }
  .block-1 {
    order: 1;
  }
  .block-2 {
    order: 2;
  }
  .block-3 {
    order: 3;
  }
  .bydesign-center-footer {
    order: 0;
  }
  .w-layout-grid.footer-component-grid {
    display: flex;
    flex-direction: column;
  }
  .inner-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0;
  }
  .reference-image {
    width: 34%;
  }
  .footer-description {
    margin-top: 3rem;
  }
  .inner-content {
    margin-top: 2rem;
  }
  .footer-bottom-content {
    margin-top: 3rem;
  }
  .padding-xhuge {
    padding: 0;
  }
}
.social-link {
  background-color: var(--white);
  border: none;
}
.social-link div {
  color: var(--dark-brown);
}
.footer-bottom-content {
  background-color: transparent;
  padding-top: unset;
  padding-bottom: 3rem;
}
.footer-title {
  font-size: 1rem;
}

.reference-image {
  object-fit: contain;
}

.footer-description {
  margin-top: unset;
}

.branch-name {
  font-weight: 300;
  font-size: 0.8rem;
  line-height: 14.35px;
  letter-spacing: 5px;
}
</style>
